"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const rsuite_1 = require("rsuite");
const react_router_dom_1 = require("react-router-dom");
const querystring_1 = require("querystring");
const resourceListQuery_1 = require("../../hooks/resourceListQuery");
const ChildComponents = __importStar(require("./components"));
exports.ResourceList = (rootProps) => {
    const { errorMessage, isProcessing, resources, handleSearch, handlePageChange, searchQuery, } = resourceListQuery_1.useResourceListQuery({ path: rootProps.path });
    const history = react_router_dom_1.useHistory();
    const renderLinkToItem = (itemId = '') => {
        return `${rootProps.path}/${itemId}?${querystring_1.stringify(searchQuery)}`;
    };
    const handleItemOpen = (itemId) => {
        const itemUrl = renderLinkToItem(itemId);
        history.push(itemUrl);
    };
    const handleItemClose = () => {
        const parentUri = renderLinkToItem();
        history.push(parentUri);
    };
    const handleItemCreate = () => {
        const parentUri = renderLinkToItem('_');
        history.push(parentUri);
    };
    const isChildVisible = (k) => {
        if (rootProps.hide && (rootProps.hide.includes(k) || rootProps.hide.includes('all'))) {
            return false;
        }
        return true;
    };
    const childrenProps = Object.assign(Object.assign({}, rootProps), { searchQuery, resources, isProcessing, errorMessage,
        handleItemOpen, handleItemClose, handleItemCreate, handleSearch, handlePageChange });
    return (react_1.default.createElement("div", null,
        isChildVisible('header') &&
            react_1.default.createElement(ChildComponents.Header, Object.assign({}, childrenProps)),
        isChildVisible('errorMessage') && errorMessage &&
            react_1.default.createElement(rsuite_1.Message, { type: "warning", description: errorMessage }),
        isChildVisible('loading') && isProcessing && (react_1.default.createElement(rsuite_1.Placeholder.Paragraph, null,
            react_1.default.createElement(rsuite_1.Loader, { center: true, content: "loading" }))),
        !isProcessing && resources.length === 0 && (react_1.default.createElement("div", { style: { padding: 100, textAlign: 'center' } }, "No content")),
        !isProcessing && resources.map((resource) => {
            const props = Object.assign(Object.assign({}, childrenProps), { resource });
            return react_1.default.createElement(ChildComponents.ListItem, Object.assign({ key: resource.id }, props));
        }),
        isChildVisible('footer') &&
            react_1.default.createElement(ChildComponents.Footer, Object.assign({}, childrenProps)),
        isChildVisible('panel') &&
            react_1.default.createElement(ChildComponents.Panel, Object.assign({}, childrenProps))));
};
//# sourceMappingURL=index.js.map